module.exports = "/chronicle-light-v2.woff2";